import { render, staticRenderFns } from "./BarangayVotersVotedChart.vue?vue&type=template&id=18e8ced3"
import script from "./BarangayVotersVotedChart.vue?vue&type=script&lang=js"
export * from "./BarangayVotersVotedChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports